import { assetsApiClient } from '@api/clients';
import { AssetInfo } from '@api/api';
import { useQuery, UseQueryResult } from 'react-query';

export const fetchAssetInfo = async (ticker: string, days: number | string): Promise<AssetInfo> => {
  const { data } = await assetsApiClient.assetsTickerGet({ ticker }, { params: { days } });

  return data;
};

interface TransformedAssetInfo extends AssetInfo {
  image?: string;
  pricesData: { change: number; data: { name: number; value: number }[] };
}

const selectQueryData = (data: AssetInfo): TransformedAssetInfo => ({
  ...data,
  pricesData: {
    change: data.price.percentageChange,
    data: data.prices.map(([timestamp, value]) => ({
      name: timestamp,
      value,
    })),
  },
});

export const useAssetInfo = (
  ticker: string,
  days: number | string,
  enabled: boolean,
): UseQueryResult<TransformedAssetInfo> => {
  return useQuery(['asset-info', ticker, days], () => fetchAssetInfo(ticker, days), {
    enabled,
    keepPreviousData: true,
    select: selectQueryData,
  });
};
